export default "__VITE_ASSET__d709c6c9__"